// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2FT2i","buttons":"Footer_buttons__28WvJ"};